import { useEffect } from "react";
import { CASES } from "../data/site";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionLabel, ContactCTA } from "../components/Shared";

export default function Casos() {
  useEffect(() => {
    document.title = "Casos il·lustratius — Orbis Forum Català";
  }, []);

  return (
    <div>
      <PageHero
        label="Casos il·lustratius"
        title="Exemples representatius de com podem ajudar"
        subtitle="Situacions dissenyades per il·lustrar el nostre àmbit d'actuació."
      />

      <section className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16">
          <Reveal>
            <div
              data-testid="cases-disclaimer"
              className="border border-ofc-gold/30 bg-ofc-gold/5 px-6 py-5 md:px-8 md:py-6"
            >
              <p className="text-sm md:text-base text-white/70 font-light leading-relaxed">
                <span className="text-ofc-gold uppercase tracking-[0.15em] text-xs block mb-2">
                  Nota important
                </span>
                Els casos que es mostren a continuació són <span className="text-white">exemples
                representatius i il·lustratius</span>. No corresponen a clients reals ni a
                projectes concrets. Es presenten únicament per mostrar situacions en què els
                nostres serveis poden resultar útils, preservant sempre la confidencialitat.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
            {CASES.map((c, i) => (
              <Reveal key={i} delay={(i % 2) * 0.08}>
                <article
                  data-testid={`case-${i}`}
                  className="bg-ofc-black p-8 md:p-12 h-full flex flex-col group hover:bg-ofc-navy transition-colors duration-500"
                >
                  <span className="text-xs uppercase tracking-[0.25em] text-ofc-gold/70">{c.tag}</span>
                  <h3 className="font-serif-display text-2xl md:text-3xl mt-5 leading-tight">{c.title}</h3>
                  <div className="h-px w-12 bg-ofc-gold/40 my-6" />
                  <div className="space-y-5">
                    <div>
                      <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-2">Situació</p>
                      <p className="text-sm text-white/60 font-light leading-relaxed">{c.context}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-2">Enfocament</p>
                      <p className="text-sm text-white/60 font-light leading-relaxed">{c.approach}</p>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </div>
  );
}
